import { IntroductionContainer, IntroductionImage } from "./styled";
import { Container } from "../../components/container";
import { texts } from "../../components/locale";

export const Introduction = () => {
  return (
    <IntroductionContainer>
      <IntroductionImage>
        <img src="https://gdb.rferl.org/01000000-0aff-0242-ee3f-08dc3235ddf6_w1920.jpg" />
        <h1>
          <span>{texts.title_1} </span>
          {texts.title_2}
        </h1>
      </IntroductionImage>
      <Container>
        <p>{texts.introduction}</p>
      </Container>
    </IntroductionContainer>
  );
};
